import { AppArea, ExperimentConfig, ExperimentName } from '@/funnels/@types'

import web_autotest_female_funnel_check from './experiments/web_autotest_female_funnel_check'
import web_summary_checkpoints_tai_chi_male from './experiments/web_summary_checkpoints_tai_chi_male'
import web_fallback_on_payment_male_us from './experiments/web_fallback_on_payment_male_us'
import web_fallback_on_payment_male_eu from './experiments/web_fallback_on_payment_male_eu'
import web_fallback_on_payment_male_row from './experiments/web_fallback_on_payment_male_row'
import web_en_countries_price_optimization from './experiments/web_en_countries_price_optimization'
import web_bulk_change_walking_female from './experiments/web_bulk_change_walking_female'
import web_yoga_printable_guide_welcome from './experiments/web_yoga_printable_guide_welcome'
import web_walking_to_lose_weight_gdn from './experiments/web_walking_to_lose_weight_gdn'
import web_walking_to_lose_weight_keyword from './experiments/web_walking_to_lose_weight_keyword'
import web_walking_female_indoor from './experiments/web_walking_female_indoor'
import web_welcome_for_search_fasting_schedule from './experiments/web_welcome_for_search_fasting_schedule'
import web_chair_yoga_challenge_landing from './experiments/web_chair_yoga_challenge_landing'
import web_welcome_for_search_fasting_lose_weight from './experiments/web_welcome_for_search_fasting_lose_weight'
import web_welcome_for_demgen_walking from './experiments/web_welcome_for_demgen_walking'
import web_yoga_female_scratch_card_before_the_paywall from './experiments/web_yoga_female_scratch_card_before_the_paywall'
import web_pilates_gamification_progress from './experiments/web_pilates_gamification_progress'
import web_fasting_fem_paywall_w_plan_benefits from './experiments/web_fasting_fem_paywall_w_plan_benefits'
import web_welcome_for_search_fasting_diet_keywords from './experiments/web_welcome_for_search_fasting_diet_keywords'
import web_chair_workouts_male_subtitles from './experiments/web_chair_workouts_male_subtitles'
import web_welcome_for_search_fasting_calculator from './experiments/web_welcome_for_search_fasting_calculator'
import web_fasting_f_personalized_coupon from './experiments/web_fasting_f_personalized_coupon'
import web_data_input_screens_optimized from './experiments/web_data_input_screens_optimized'
import web_tai_chi_al_risk_free_offer from './experiments/web_tai_chi_al_risk_free_offer'
import web_tai_chi_al_paywall_plan_benefits from './experiments/web_tai_chi_al_paywall_plan_benefits'
import web_sp_monetization_female_fasting from './experiments/web_sp_monetization_female_fasting'
import web_paywall_with_social_proof from './experiments/web_paywall_with_social_proof'
import web_glp_upsell_fakedoor from './experiments/web_glp_upsell_fakedoor'
import web_gamification_of_fallback_offer from './experiments/web_gamification_of_fallback_offer'
import web_welcome_for_applovin_tai_chi_walking from './experiments/web_welcome_for_applovin_tai_chi_walking'
import web_tai_chi_fem_v2_social_proof from './experiments/web_tai_chi_fem_v2_social_proof'
import web_tai_chi_female_v2_moto_block from './experiments/web_tai_chi_female_v2_moto_block'
import web_tai_chi_fem_v2_gifs_exercise from './experiments/web_tai_chi_fem_v2_gifs_exercise'
import web_pro_version_activity_funnels from './experiments/web_pro_version_activity_funnels'
import web_female_pilates_bulk_update from './experiments/web_female_pilates_bulk_update'
import web_fsa_hsa_payment_method from './experiments/web_fsa_hsa_payment_method'
import web_prediction_cookie from './experiments/web_prediction_cookie'
import web_female_tai_chi_walking_v2_fr from './experiments/web_female_tai_chi_walking_v2_fr'
import web_feedback_with_social_proof from './experiments/web_feedback_with_social_proof'
import web_upsell_price_based_card_type from './experiments/web_upsell_price_based_card_type'
import web_upsells_on_tai_chi from './experiments/web_upsells_on_tai_chi'
import web_water_fasting_health_milestone_kit from './experiments/web_water_fasting_health_milestone_kit'
import web_water_fasting_models_from_creos from './experiments/web_water_fasting_models_from_creos'
import web_models_from_creos from './experiments/web_models_from_creos'
import web_female_tai_chi_walking_v2_de from './experiments/web_female_tai_chi_walking_v2_de'
import web_planpicker_redesign_female from './experiments/web_planpicker_redesign_female'
import web_print_tai_chi_f_bmi_post_funnel from './experiments/web_print_tai_chi_f_bmi_post_funnel'
import web_fasting_fem_sales_tax_exclusion_i3 from './experiments/web_fasting_fem_sales_tax_exclusion_i3'
import web_tai_chi_male_checkout_update from './experiments/web_tai_chi_male_checkout_update'
import web_revisit_last_section_female from './experiments/web_revisit_last_section_female'
import web_less_sleep_more_calories from './experiments/web_less_sleep_more_calories'
import web_refactor_result_complete from './experiments/web_refactor_result_complete'
import web_tai_chi_fem_v2_questions_counter from './experiments/web_tai_chi_fem_v2_questions_counter'
import web_tai_chi_v2_al_prediction_cookie_i2 from './experiments/web_tai_chi_v2_al_prediction_cookie_i2'
import web_reprice_upsells_nonus from './experiments/web_reprice_upsells_nonus'
import web_legacy_plan_picker_tai_chi_yoga_walking from './experiments/web_legacy_plan_picker_tai_chi_yoga_walking'
import web_chair_workouts_large_checkout from './experiments/web_chair_workouts_large_checkout'
import web_tai_chi_higher_prices from './experiments/web_tai_chi_higher_prices'

const experimentsConfig: Partial<Record<AppArea, { [key: ExperimentName<string>]: ExperimentConfig[] }>> = {
	// fasting
	female: {
		web_gamification_of_fallback_offer,
		web_fsa_hsa_payment_method,
		web_autotest_female_funnel_check,
		web_fasting_fem_paywall_w_plan_benefits,
		web_fasting_f_personalized_coupon,
		web_data_input_screens_optimized,
		web_sp_monetization_female_fasting,
		web_glp_upsell_fakedoor,
		web_feedback_with_social_proof,
		web_planpicker_redesign_female,
		web_fasting_fem_sales_tax_exclusion_i3,
		web_revisit_last_section_female,
		web_reprice_upsells_nonus,
	},
	male: {
		web_en_countries_price_optimization,
		web_fallback_on_payment_male_us,
		web_fallback_on_payment_male_eu,
		web_fallback_on_payment_male_row,
	},
	main: {
		web_models_from_creos,
		web_welcome_for_search_fasting_schedule,
		web_welcome_for_search_fasting_lose_weight,
		web_welcome_for_search_fasting_diet_keywords,
		web_welcome_for_search_fasting_calculator,
	},

	// yoga
	'activity-female-yoga': {
		web_yoga_female_scratch_card_before_the_paywall,
		web_legacy_plan_picker_tai_chi_yoga_walking,
	},
	'activity-male-chair-workouts': {
		web_chair_workouts_male_subtitles,
		web_paywall_with_social_proof,
		web_fallback_on_payment_male_us,
		web_fallback_on_payment_male_eu,
		web_fallback_on_payment_male_row,
		web_chair_workouts_large_checkout,
	},
	'main-yoga': {
		web_yoga_printable_guide_welcome,
		web_chair_yoga_challenge_landing,
	},

	// walking
	'activity-female-walking': {
		web_en_countries_price_optimization,
		web_walking_female_indoor,
		web_bulk_change_walking_female,
		web_welcome_for_demgen_walking,
		web_pro_version_activity_funnels,
		web_upsell_price_based_card_type,
		web_legacy_plan_picker_tai_chi_yoga_walking,
	},
	'activity-male-walking': {
		web_fallback_on_payment_male_us,
		web_fallback_on_payment_male_eu,
		web_fallback_on_payment_male_row,
		web_upsell_price_based_card_type,
	},
	'activity-female-nordic-walking-fwf': {},
	'female-printable-walking': {},
	'main-walking': {
		web_walking_to_lose_weight_gdn,
		web_walking_to_lose_weight_keyword,
	},

	// pilates
	'activity-female-pilates': {
		web_pilates_gamification_progress,
		web_female_pilates_bulk_update,
	},
	'activity-female-boudoir-pilates-fwf': {},

	// activity
	'activity-female-v2': {},
	'activity-male': {},
	'main-activity': {},

	// tai-chi
	'activity-female-tai-chi': {},
	'activity-female-tai-chi-walking': {},
	'activity-female-tai-chi-walking-v2': {
		web_gamification_of_fallback_offer,
		web_tai_chi_fem_v2_social_proof,
		web_tai_chi_female_v2_moto_block,
		web_tai_chi_fem_v2_gifs_exercise,
		web_pro_version_activity_funnels,
		web_fsa_hsa_payment_method,
		web_prediction_cookie,
		web_female_tai_chi_walking_v2_fr,
		web_upsell_price_based_card_type,
		web_female_tai_chi_walking_v2_de,
		web_upsells_on_tai_chi,
		web_less_sleep_more_calories,
		web_tai_chi_fem_v2_questions_counter,
		web_tai_chi_v2_al_prediction_cookie_i2,
		web_reprice_upsells_nonus,
		web_legacy_plan_picker_tai_chi_yoga_walking,
		web_tai_chi_higher_prices,
	},
	'activity-female-tai-chi-walking-pr': {
		web_upsells_on_tai_chi,
		web_print_tai_chi_f_bmi_post_funnel,
		web_refactor_result_complete,
		web_tai_chi_higher_prices,
	},
	'activity-male-tai-chi-walking': {},
	'activity-male-tai-chi-yoga': {
		web_summary_checkpoints_tai_chi_male,
		web_fallback_on_payment_male_us,
		web_fallback_on_payment_male_eu,
		web_fallback_on_payment_male_row,
		web_tai_chi_male_checkout_update,
	},
	'activity-male-tai-chi-yoga-pr': {
		web_tai_chi_male_checkout_update,
	},
	'activity-female-chair-tai-chi-fwf': {},
	'activity-male-chair-tai-chi-fwf': {},
	'tai-chi-male-golfers-fwf': {},
	'main-tai-chi': {},
	'main-tai-chi-walking': {
		web_tai_chi_fem_v2_social_proof,
	},

	// glp
	'female-glp': {},
	'glp-1': {},

	// calisthenics

	// japanese-walking
	'activity-female-walking-japanese': {},
	'activity-female-walking-japanese-v2': {},

	// asian-pilates

	// military

	// water-fasting
	'female-water-fasting': {
		web_water_fasting_health_milestone_kit,
		web_reprice_upsells_nonus,
		web_water_fasting_models_from_creos,
	},

	// ayurveda fwf
	'female-ayurveda-fwf': {},

	// high-protein

	// diets
	'female-cortisol-diet': {},
	'female-menopause-diet': {},
	'female-mediterranean-diet': {},
	'female-anti-inflammatory-diet': {},
	'female-ramadan-fwf': {},

	// applovin
	'activity-female-yoga-al': {},
	'activity-female-walking-al': {},
	'activity-male-tai-chi-walking-al': {},
	'female-al': {},
	'female-water-fasting-al': {},
	'activity-female-tai-chi-walking-al': {},
	'activity-female-tai-chi-walking-v2-al': {
		web_tai_chi_al_risk_free_offer,
		web_tai_chi_al_paywall_plan_benefits,
		web_welcome_for_applovin_tai_chi_walking,
		web_upsells_on_tai_chi,
		web_refactor_result_complete,
		web_tai_chi_v2_al_prediction_cookie_i2,
		web_reprice_upsells_nonus,
		web_tai_chi_higher_prices,
	},

	// other
}

export default experimentsConfig
